var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M39.828 1.172a4 4 0 00-5.656 0L21 14.344 7.828 1.172a4 4 0 00-5.656 5.656L15.344 20 2.172 33.172a4 4 0 105.656 5.656L21 25.656l13.172 13.172a4 4 0 005.656-5.656L26.656 20 39.828 6.828a4 4 0 000-5.656z","fill":"#1029B9","fillRule":"nonzero"}));
}

Cross.defaultProps = {"viewBox":"0 0 41 41"};

module.exports = Cross;

Cross.default = Cross;
